class SystemSettings {
  static PENDO_API_KEY: string = 'REACT_APP_PENDO_API_KEY';

  static PENDO_DEFAULT_API_KEY: string = 'REACT_APP_PENDO_DEFAULT_API_KEY';

  static ENABLE_ES_PLATFORM_GA: string = 'com.boomi.platform.ui.eventstreams.ga';

  static ENABLE_ES_REACT_UI: string = 'com.boomi.eventstreams.enableReactUi';

  static ENABLE_PUBLISHER_UI: string = 'com.boomi.platform.ui.enablePublisherUI';

  static ENABLE_CATALOG_SERVICE_ADMIN_UI: string = 'com.boomi.platform.ui.enableCatalogServiceAdminUI';

  static DISCOVER_URL: string = 'com.boomi.platform.ui.discover.url';

  private settings: Map<string, string> | undefined;

  protected setSystemSettings(settings: Map<string, string>): void {
    this.settings = settings;
  }

  protected getSystemSetting(settingName: string, defaultValue: any): string {
    const value = this.settings?.get(settingName) as any;
    if (value !== 'false' && !!value) {
      return value;
    }
    return defaultValue;
  }

  protected getSystemSettingAsBoolean(settingName: string, defaultValue: boolean): boolean {
    const value = this.settings?.get(settingName) as any;
    if (!value) {
      return defaultValue;
    }
    return (String(value).toLowerCase() === 'true');
  }
}

export default SystemSettings;
